var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestDesktopSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m4.409 3.877 2.158-.8L16 0l-3.594 10.8-3.89 4.7-1.682-3.287-.2-1.703 5.563-6.633s1.505-1.45 1.452-1.536-1.039.482-1.039.482l-7.086 6.3-1.23.476-1.275-.713L0 7.7z"
})));
export default SvgPinterestDesktopSend;